import React, { Component } from "react";
import { FormErrors, reduxForm } from "redux-form";
import {ff, form, HorizontalLoader} from "@mc/mc-legacy";
import { Button } from "reactstrap";
import { toastr } from "react-redux-toastr";
import SpravaUctuApi from "../../api/gen/core/SpravaUctuApi";
import * as TwoFactorType from "../../api/gen/core/TwoFactorType";
/**
 * Formulář potvrzení pomocí SMS.
 */
type FormData = { smsCode: string };
class SmsConfirm extends Component<any, { twoFactorTypeResponse: any; userCodeSubmitErrorMessage: any }> {
  static validate = (data: FormData) => {
    const errors: FormErrors<FormData> = {};

    if (!data.smsCode) {
      errors.smsCode = "Ověřovací kód je povinný";
    }

    return errors;
  };

  constructor(props) {
    super(props);
    this.state = {
      twoFactorTypeResponse: props.twoFactorTypeResponse,
      userCodeSubmitErrorMessage: null,
    };
  }

  handleNewSms = () => {
    const { twoFactorTypeResponse } = this.state;
    const { untouch, change } = this.props;
    SpravaUctuApi.twoFactorRepeatSms({ repeatRequestCode: twoFactorTypeResponse.repeatRequestCode }).then((resp) => {
      if (resp) {
        toastr.success("", {
          component: (
            <div>
              Byla odeslaná nová SMS s ověřovacím kódem na váš mobilní telefon{" "}
              <span className="text-nowrap">{resp.kontakt}</span>
            </div>
          ),
        });
        this.setState({
          twoFactorTypeResponse: resp,
          userCodeSubmitErrorMessage: null,
        });
        change("smsCode", "");
        untouch("smsCode");
      }
    });
  };
  customHandleSubmit = (event) => {
    const { onSuccess, onSubmit, handleSubmit } = this.props;
    handleSubmit((data) => {
      return onSubmit(data).then((resp) => {
        switch (resp.twoFactorType) {
          case TwoFactorType.SMS:
            // chyba ověření, máme stále SMS
            this.setState({
              twoFactorTypeResponse: resp,
              userCodeSubmitErrorMessage: "Zadaný SMS kód není správný",
            });
            break;

          default:
            // jiná metoda nebo ok končíme
            onSuccess(resp);
        }
      });
    })(event);
  };

  render() {
    const { error, submitting } = this.props;
    const { userCodeSubmitErrorMessage, twoFactorTypeResponse } = this.state;
    let disabled = submitting || twoFactorTypeResponse.remainingAttempts === 0;
    return (
      <form.Form className={"form"} horiznotal onSubmit={this.customHandleSubmit}>
        <form.FormBody>
          <h4>Ověření pomocí SMS</h4>
          <p>Zadejte 4místný kód, který jsme odeslali na váš mobilní telefon {twoFactorTypeResponse.kontakt}</p>
          {userCodeSubmitErrorMessage && twoFactorTypeResponse.remainingAttempts > 0 && (
            <p>Zbývající počet pokusů: {twoFactorTypeResponse.remainingAttempts}</p>
          )}
          {userCodeSubmitErrorMessage && twoFactorTypeResponse.remainingAttempts === 0 && (
            <p>Vyčerpali jste maximální počet pokusů na zadání kódu, vyžádejte si prosím nový kód</p>
          )}
          {error && <form.ValidationErrors error={error} />}
          {userCodeSubmitErrorMessage && <form.ValidationErrors error={userCodeSubmitErrorMessage} />}
          <ff.String
            autoComplete={"off"}
            label={false}
            placeholder="Ověřovací kód"
            name={"smsCode"}
            disabled={disabled}
            required
          />
        </form.FormBody>
        <form.FormActions submitting={submitting} submitButton={false}>
            <Button disabled={disabled} className={"btn btn-primary py-15"}>
                Ověřit kód
                {submitting && <HorizontalLoader/>}
            </Button>
            <Button color="link" className="ml-2 pr-0 pl-0" onClick={this.handleNewSms}>
                Zaslat SMS znovu
            </Button>
        </form.FormActions>
      </form.Form>
    );
  }
}

const SmsConfirmForm = reduxForm<FormData, any>({
  form: "smsConfirm",
  validate: SmsConfirm.validate,
})(SmsConfirm);
export default SmsConfirmForm;
